import React, {Component} from 'react';

import screen from '../images/print-apps.jpg';

export default class Print extends Component{
    render(){
        return(
            <img src={screen} />
        )
    }
}


// WEBPACK FOOTER //
// ./src/views/Print.js